import DJHBooks from '../data/BookChapterList.json'
const books = Object.keys(DJHBooks);

export const getAvailableSegment = (AvailableContent, language, version) => {
  let book = null;
  books.forEach(b => {
  if (!book) {
      if (AvailableContent.content[language][version][b]) {
        book = b
      }
    }
  })
  if (!book) return null;
  return AvailableContent.content[language][version][book].segments[0]
}